"use client";

import { useTranslations, useLocale } from 'next-intl';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import styles from './Header.module.css';

export default function Header() {
  const t = useTranslations('Header');
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();

  const switchLanguage = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const nextLocale = e.target.value;
    document.cookie = `NEXT_LOCALE=${nextLocale}; path=/; max-age=31536000`;
    
    let pathWithoutLocale = pathname;
    if (pathname.startsWith(`/${locale}`)) {
      pathWithoutLocale = pathname.replace(`/${locale}`, '') || '/';
    }
    
    const newPath = nextLocale === 'en' ? pathWithoutLocale : `/${nextLocale}${pathWithoutLocale === '/' ? '' : pathWithoutLocale}`;
    
    router.push(newPath);
    router.refresh();
  };

  const [user, setUser] = useState<any>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) {
      try { setUser(JSON.parse(u)); } catch(e){}
    }
  }, [pathname]); // Refresh when path changes


  if (pathname.includes('/login') || pathname.includes('/register')) {
    return null;
  }

  return (
    <header className={styles.header}>
      <div className={`container ${styles.headerInner}`}>
        <Link href={locale === 'en' ? '/' : `/${locale}`} className={styles.logo}>
          <img src="/trans_whale.png" alt="Whale Illustration" width={105} height={105} />
          <span className={styles.logoText}>W I C H P D F</span>
        </Link>
        <nav className={`${styles.nav} ${mobileMenuOpen ? styles.mobileOpen : ''}`}>
          <Link href={`/${locale}/#conference`} onClick={() => setMobileMenuOpen(false)}>{locale === 'zh' ? '世界非遗大会' : 'Conference'}</Link>
          <Link href={`/${locale}/marketplace`} onClick={() => setMobileMenuOpen(false)}>{locale === 'zh' ? '非遗推荐项目' : 'Projects'}</Link>
          <Link href={`/${locale}/certification`} onClick={() => setMobileMenuOpen(false)}>{locale === 'zh' ? '认证中心' : 'Certification'}</Link>
          <Link href={`/${locale}/news`} onClick={() => setMobileMenuOpen(false)}>{locale === 'zh' ? '新闻' : 'News'}</Link>
          <Link href={`/${locale}/about`} onClick={() => setMobileMenuOpen(false)}>{locale === 'zh' ? '关于我们' : 'About Us'}</Link>
        </nav>
        <div className={styles.actions}>
          <select
            className={styles.langSelect}
            value={locale}
            onChange={switchLanguage}
          >
            <option value="en">English</option>
            <option value="zh">中文</option>
          </select>
          <Link href={`/${locale}/profile`} className={styles.authLink}>
            {locale === 'zh' ? '个人中心' : 'Profile'}
          </Link>
          <button className={styles.burger} onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            ☰
          </button>
        </div>
      </div>
    </header>
  );
}
